module.exports = file => () => {
  const normalized = String(file || '').replace(/^\/+/, '').replace(/\.vue$/i, '')
  return import('@/views/' + normalized + '.vue').catch(() =>
    import('@/views/' + normalized + '/index.vue')
  )
}



// WEBPACK FOOTER //
// ./src/router/import-production.js